import { render, staticRenderFns } from "./ScoreClassCreator.vue?vue&type=template&id=69f7e456&scoped=true&"
import script from "./ScoreClassCreator.vue?vue&type=script&lang=ts&"
export * from "./ScoreClassCreator.vue?vue&type=script&lang=ts&"
import style0 from "./ScoreClassCreator.vue?vue&type=style&index=0&id=69f7e456&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f7e456",
  null
  
)

export default component.exports